export default "__VITE_ASSET__db1706ad__"